<template>
  <div class="page-content">
    <section>
      <div
        class="
          content-wrap previous-wrap
        ">
        <el-button
          type="info"
          icon="
            el-icon-arrow-left
          "
          size="small"
          round
          @click="() => fallback()"
        >
          ย้อนกลับ
        </el-button>
      </div>
    </section>

    <section class="content-wrap content-action" style="margin: 0 auto">
      <div size="full" class="home-address">
        <div>
          <b>
            <span>
              {{ addressNo || "บ้านเลขที่" }}
            </span>
          </b>
          <p class="subtitle">
            <span v-if="structure"> {{ structure }} - </span>
            {{ projectName || "ชื่อโครงการ" }}
          </p>
        </div>
      </div>
      <hr />
      <div size="none" class="home-action">
        <el-button
          type="sc-asset"
          icon="
            el-icon-edit
          "
          @click="() => (editor.open = true)"
        >
          แก้ไข
        </el-button>
      </div>
    </section>

    <NonScHomeRole
      :roles="roles"
      :total="paging.total"
      @page-change="(page) => fetchRole(page)"
      @create-user="(value) => createUser(value)"
      @update-user="(value) => updateUser(value)"
      @remove-user="(id) => removeUser(id)"
      @create-role="(value) => createRole(value)"
      @remove-role="(id) => removeRole(id)"
    />

    <NonScHomeEditor
      :mode="'update'"
      :open="editor.open"
      :form="editor.form"
      @submit="(value) => updateHome(value)"
      @remove="() => (remove.open = true)"
      @closed="() => (editor.open = false)"
    />

    <NonScAlert
      :open="alert.open"
      :type="alert.type"
      :message="alert.message"
      @closed="() => (alert.open = false)"
    />

    <NonScAlert
      :open="remove.open"
      :type="'error'"
      :head="remove.head"
      :message="remove.message"
      :cancel="true"
      @confirm="() => removeHome(homeId)"
      @closed="() => (remove.open = false)"
    />

    <!-- Loader -->
    <div
      v-loading.fullscreen.lock="loader"
      element-loading-background="rgba(0, 0, 0, 0.4)"
    ></div>
  </div>
</template>

<script>
// Common
import { NonScCommon as Common } from "../../common/nonsc.common"

import { NonScHomeCommon as HomeCommon } from "../../common/nonsc-home.common"

// Components
import NonScAlert from "../../components/NonScAlert"
import NonScHomeEditor from "./NonScHomeEditor"
import NonScHomeRole from "./NonScHomeRole"

// Services
// eslint-disable-next-line import/no-cycle
import { NonScFeature } from "../../feature"

// Utils
import { ValidateUtility as Validate } from "../../utils/validate"

export default {
  components: {
    NonScAlert,
    NonScHomeEditor,
    NonScHomeRole,
  },
  data() {
    // Init Title
    const title = `ข้อมูลบ้าน`

    // Init Loader
    const loader = false

    // Default Input
    const { input, detail } = HomeCommon

    // Home Detail
    const home = { ...detail }

    /** @type {import('../../common/nonsc-user-role.common').RoleItem[]} */
    const roles = []

    // Init Alert
    const alert = {
      open: false,
      type: "error",
      message: "null",
    }

    // Remove State
    const remove = {
      open: false,
      head: "ลบข้อมูล",
      message: null,
    }

    // Init Editor
    const editor = {
      open: false,
      form: { ...input },
    }

    // Init Editor
    const creator = {
      open: false,
      form: { ...input },
    }

    // Init Paging
    const paging = {
      page: 1,
      limit: 10,
      count: 5,
      total: 0,
    }

    return {
      title,
      loader,
      home,
      editor,
      creator,
      roles,
      paging,
      alert,
      remove,
    }
  },
  computed: {
    homeId() {
      if (this.home) {
        return this.home.id
      }
      return undefined
    },
    clientHome() {
      return NonScFeature.home
    },
    clientUser() {
      return NonScFeature.user
    },
    clientRole() {
      return NonScFeature.role
    },
    structure() {
      // Validate Home
      if (!this.home) return undefined

      // Home Props
      const { structure } = this.home

      // Home Structure
      if (structure) {
        return structure.name
      }
      return undefined
    },
    project() {
      if (this.home) {
        return this.home.project
      }
      return undefined
    },
    projectId() {
      if (this.project) {
        return this.project.id
      }
      return undefined
    },
    projectName() {
      if (this.project) {
        return `โครงการ${this.project.name}`
      }
      return undefined
    },
    projectCode() {
      if (this.project) {
        return this.project.code
      }
      return undefined
    },
    address() {
      if (this.home) {
        return this.home.address
      }
      return undefined
    },
    addressNo() {
      if (this.address) {
        return "เลขที่ ".concat(this.address.addressNo)
      }
      return undefined
    },
    addressRoad() {
      // Validate Address
      if (!this.address) return undefined

      // Address Road
      const { addressRoad } = this.address

      // Set Address Rord
      if (addressRoad) {
        return "ถนน".concat(addressRoad)
      }
      return undefined
    },
    addressDetail() {
      if (this.address) {
        // Address Props
        const {
          amphurPrefix,
          amphurName,
          tumbonPrefix,
          tumbonName,
          provinceName,
          zipCode,
        } = this.address

        // Set Tumbom
        const tumbon = tumbonPrefix.concat(tumbonName)

        // Set Amphur
        const amphur = amphurPrefix.concat(amphurName)

        // Set Province
        const province = "จังหวัด".concat(provinceName)

        return [tumbon, amphur, province, zipCode].join(" ")
      }
      return undefined
    },
  },
  watch: {
    home: {
      handler(value) {
        this.setForm(value)
      },
      deep: true,
    },
    "remove.open": function removeOpenWatcher(open) {
      // Validate State
      if (!open) return

      // Confirm Message
      this.remove.message = `ต้องการลบข้อมูลบ้าน${this.addressNo}?`
    },
  },
  mounted() {
    // Init Title
    this.$emit("sub-title", this.title)

    // Fetch Home
    this.fetchHome(this.fetchRole)
  },
  methods: {
    setForm(input) {
      // Validate Input
      if (!input) return

      /** @type {import('../../common/nonsc-home.common').HomeDetail} */
      const { area, structure, address, transferDate } = input

      // Set Form
      const form = {
        ...HomeCommon.input,
        ...address,
        area,
      }

      // Set Home Structure
      if (structure) {
        form.structure = structure.name
      }

      // Set Transfer Date
      form.transferDate = this.setDate(transferDate)

      // Set Editor Form
      this.editor.form = { ...form }
    },
    setDate(input) {
      // Date Validator
      const isDate = Validate.isDate(input)

      // Validate Date
      if (!isDate) return null

      // Init Date
      const date = new Date(input)

      // Pad String
      const pad = (e) => `${e}`.padStart(2, "0")

      return [
        pad(date.getFullYear()),
        pad(date.getMonth() + 1),
        pad(date.getDate()),
      ].join("-")
    },
    async fetchHome(callback) {
      // Loading
      this.loader = true

      try {
        // Route Parameters
        const { homeId } = this.$route.params

        // Validate Home ID
        if (!homeId) {
          throw new Error("Invalid Parameters")
        }

        // Fetch Home
        const home = await this.clientHome.get(homeId)

        // Set Home Detail
        this.home = home

        // Callback Validator
        const callable = typeof callback === "function"

        // Execute Callback
        if (callable) await callback()
      } catch ({ message }) {
        this.fallback(message)
      } finally {
        setTimeout(() => {
          this.loader = false
        }, 400)
      }
    },
    async fetchRole(page) {
      // Loading
      this.loader = true

      try {
        // Validate Home
        if (!this.home) {
          throw new Error("Invalid Parameters")
        }

        /** @type {import('../../common/nonsc-home.common').HomeDetail} */
        const { id, project } = this.home

        // Filter Props
        const homeId = id
        const projectId = project.id

        // Limit Props
        const { limit } = this.paging

        // Fetch Home Role
        const { items, total } = await this.clientRole.list({
          homeId,
          projectId,
          page,
          limit,
        })

        // Set User
        this.roles = items

        // Set Paging
        Object.assign(this.paging, { page, total })
      } catch (_) {
        // Reset User
        this.roles = []

        // Reset Paging
        Object.assign(this.paging, { page: 1, total: 0 })
      } finally {
        setTimeout(() => {
          this.loader = false
        }, 400)
      }
    },
    async updateHome(value) {
      // Loading
      this.loader = true

      try {
        // Validate Home ID
        if (!this.homeId || !value) {
          throw new Error("Invalid Parameters")
        }

        // Update Props
        const { structure, addressRoad, transferDate } = value

        // Set Area
        const area = Common.area(value.area)

        // Set Location
        const address = Common.setLocation(value)

        // Set Address
        Object.assign(address, { addressRoad })

        // Set Update Payload
        const payload = {
          structure,
          area,
          address,
        }

        // Omit an empty date so a home without one keeps NULL
        if (transferDate) {
          payload.transferDate = transferDate
        }

        // Request Update
        await this.clientHome.update(this.homeId, payload)
      } catch (error) {
        this.notify(Common.error(error))
      } finally {
        await this.fetchHome()
      }
    },
    async removeHome(id) {
      // Validate ID
      if (!id) return

      // Loading
      this.loader = true

      try {
        // Request Remove Home
        await this.clientHome.remove(id)

        // Fallback Route
        this.fallback()
      } catch (error) {
        this.notify(Common.error(error))
      } finally {
        setTimeout(() => {
          this.loader = false
        }, 400)
      }
    },
    async createUser(value) {
      // Validate ID
      if (!value) return

      // Loading
      this.loader = true

      try {
        // Create Home ID
        const payload = { ...value, homeId: this.homeId }

        // Request Create User
        await this.clientUser.create(payload)
      } catch (error) {
        this.notify(Common.error(error))
      } finally {
        await this.fetchRole()
      }
    },
    async updateUser(value) {
      // Validate ID
      if (!value || !value.id) return

      // Loading
      this.loader = true

      try {
        // Update Props
        const { id } = value

        // Request Update User
        await this.clientUser.update(id, { ...value, homeId: this.homeId })
      } catch (error) {
        this.notify(Common.error(error))
      } finally {
        await this.fetchRole()
      }
    },
    async removeUser(id) {
      // Validate ID
      if (!id) return

      try {
        await this.clientUser.remove(id)
      } catch (error) {
        this.notify(Common.error(error))
      } finally {
        await this.fetchRole()
      }
    },
    async createRole(value) {
      // Create Props
      const { mobileNo, role } = value

      // Validate Props
      if (!mobileNo || !role) return

      // Loading
      this.loader = true

      try {
        // Set Home & Project
        const { homeId } = this
        const { projectId } = this

        // Set Payload
        const payload = {
          projectId,
          homeId,
          mobileNo,
          role,
        }

        // Request Create Role
        await this.clientRole.create(payload)
      } catch (error) {
        this.notify(Common.error(error))
      } finally {
        await this.fetchRole()
      }
    },
    async removeRole(id) {
      // Validate ID
      if (!id) return

      // Loading
      this.loader = true

      try {
        await this.clientRole.remove(id)
      } catch (error) {
        this.notify(Common.error(error))
      } finally {
        await this.fetchRole()
      }
    },
    notify(message) {
      // Validate Message
      if (!message) return

      // Set Notice
      const notice = () => Object.assign(this.alert, { open: true, message })

      // Set Alert
      setTimeout(notice, 400)
    },
    fallback(message) {
      // Route Props
      const { name } = this.$route

      // Fallback Route
      const route = { name: null }

      // Filter Route
      switch (name) {
        // Project Fallback
        case "nonsc-project-home-detail":
          // Project ID
          route.name = "nonsc-project-home"
          route.params = { projectId: this.$route.params.projectId }
          break

        // Home Fallback
        case "nonsc-home-detail":
          route.name = "nonsc-home-list"
          break

        default:
          break
      }

      // Fallback Info
      if (message) {
        // eslint-disable-next-line no-console
        console.warn("nonsc-home-detail.fallback", message)
      }

      // Forward Route
      this.$router.push(route)
    },
  },
}
</script>

<style lang="css" scoped>

.previous-wrap {
  display      : flex;
  margin-top   : var(--size-md);
  margin-bottom: 0;
}

.content-wrap {
  gap       : var(--size-sm);
  background: white;
}
.content-wrap.previous-wrap {
  padding         : 0;
  align-items     : flex-start;
  background-color: unset;
}

.content-action {
  display: flex;
  align-items: center;
  gap: var(--size-sm);
}
.content-action hr {
  display: none;
}
.content-action [size="full"] {
  flex: 1;
}
.content-action hr {
  display: none;
}

.address-detail {
  flex: 1;
}

.home-address {
  display: flex;
  gap: var(--size-md);
  align-items: center;
}
.home-action {
  display: flex;
  gap: var(--size-sm);
}

.title {
  font-size: 1.125rem;
  font-weight: bold;
}

@media screen and (max-width: 1024px) {
  .content-action {
    flex-direction: column;
  }
  .content-action [size] {
    width: 100%;
  }
  .content-action hr {
    display: block;
  }

  .home-action {
    justify-content: flex-end;
  }
}

@media screen and (max-width: 480px) {
  .home-address {
    align-items: flex-start;
  }
}
</style>
